import React, { useState } from "react";
import axios from "axios";
import { Alert, Box, Button, Checkbox, CircularProgress, FormControlLabel, TextField, Typography } from "@mui/material";
import { Cartao, Pagina } from "./ui/Painel";
import { CORES } from "../utils/participante";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [mensagem, setMensagem] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateFields = () => {
    const errors = {};
    if (!name.trim()) errors.name = "Nome é obrigatório.";
    if (!email.trim()) errors.email = "E-mail é obrigatório.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "E-mail inválido.";
    if (!password) errors.password = "Senha é obrigatória.";
    else if (password.length < 6) errors.password = "A senha deve ter pelo menos 6 caracteres.";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem(null);
    if (!validateFields()) return;

    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, {
        name,
        email,
        password,
        isAdmin,
      });
      setMensagem({ tipo: "success", texto: `${isAdmin ? "Administrador" : "Usuário"} cadastrado com sucesso!` });
      setName("");
      setEmail("");
      setPassword("");
    } catch (err) {
      console.error(err);
      setMensagem({ tipo: "error", texto: "Erro ao registrar o usuário. Tente novamente." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Pagina
      eyebrow="Cadastros"
      titulo="Cadastrar administrador"
      descricao="Crie um acesso ao painel. Administradores veem todas as distritais e podem gerenciar cadastros e importações."
      largura={720}
    >
      <Cartao titulo="Dados de acesso">
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {mensagem && <Alert severity={mensagem.tipo}>{mensagem.texto}</Alert>}

          <TextField
            label="Nome"
            size="small"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!validationErrors.name}
            helperText={validationErrors.name}
          />
          <TextField
            label="E-mail"
            type="email"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!validationErrors.email}
            helperText={validationErrors.email}
          />
          <TextField
            label="Senha"
            type="password"
            size="small"
            fullWidth
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!validationErrors.password}
            helperText={validationErrors.password || "Mínimo de 6 caracteres"}
          />

          <FormControlLabel
            control={<Checkbox checked={isAdmin} onChange={() => setIsAdmin(!isAdmin)} size="small" />}
            label={
              <Typography sx={{ fontSize: 13, color: CORES.texto }}>
                Criar como administrador
              </Typography>
            }
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" type="submit" disabled={loading} sx={{ minWidth: 140 }}>
              {loading ? <CircularProgress size={20} color="inherit" /> : "Cadastrar"}
            </Button>
          </Box>
        </Box>
      </Cartao>
    </Pagina>
  );
};

export default Register;
